import React, { act, useEffect, useState } from "react";
import GreetserviceStep2 from "./GreetserviceStep2";
import Login from "./Login";
import { navigate } from "gatsby";
import GuestDetails, { GuestDetailsForm } from "./GuestDetails";
import Checkout from "./Checkout";
import CheckoutDetails from "./Checkout";
import NewCommonBanner from "../../../../components/common/banner/NewCommonBanner";
import NewStyleBanner from "../../../../components/common/banner/NewStyleBanner";

const AtithyaServices = () => {
  let data
  let banner_section;
  let params;
  if (typeof window !== "undefined" && window.sessionStorage) {
    banner_section = JSON.parse(sessionStorage.getItem("banner_section"));
    data = JSON.parse(sessionStorage.getItem("greetServiceData"));
    params = new URLSearchParams(window.location.search);
  }
  const tab = params && params?.get("tab");
  const [activeTab, setActiveTab] = useState(parseInt(tab));

  // Update URL when tab changes
  const handleNext = (tab) => {
    setActiveTab((prev) => Math.min(prev + 1, 5));

    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      params.set("tab", tab); // set query param
      // console.log("paramns",window.location.pathname,params)
      navigate(`${window.location.pathname}?${params.toString()}`, {
        replace: true,
      });
    }
  };

  const tabClass = (tab) => {
    if (tab === activeTab) return "bg-primary text-white";
    if (tab < activeTab) return "bg-orange-500 text-white";
    return "bg-gray-300 text-black";
  };

  // When component mounts, read query param from URL
  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      const tab = params.get("tab");
      if (tab) {
        setActiveTab(parseInt(tab));
      }
    }
  }, []);

  return (
    <div>
      <NewStyleBanner banner_section={banner_section} />
      <div
        className="w-full font-redhatRegular bg-right bg-no-repeat "
        style={{
          backgroundImage:
            "url('https://d31szslsujr0rm.cloudfront.net/bg_1_954dccc7f3.svg')",
        }}
      >
        {activeTab === 2 && (
          <GreetserviceStep2
            data={data}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            handleNext={handleNext}
            tabClass={tabClass}
          />
        )}
        {activeTab === 3 && (
          <Login handleNext={handleNext} tabClass={tabClass} activeStepTab={activeTab} />
        )}
        {activeTab === 4 && (
          <GuestDetailsForm handleNext={handleNext} tabClass={tabClass} activeTab={activeTab} />
        )}
        {activeTab === 5 && (
          <CheckoutDetails handleNext={handleNext} tabClass={tabClass} activeTab={activeTab} />
        )}
      </div>
    </div>
  );
};

export default AtithyaServices;
